import * as Sentry from '@sentry/react'
import environment from '../../utils/environment'
import React from 'react'

export const SentryWrapper = ({ children }) => {
  if (environment.isBrowser) Sentry.init(environment.SENTRY)
  return <>{children}</>
}
